import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../_infrastructure/services/auth/user-auth/auth.service';
import { UnsubscribeOnDestroyAdapter } from '../../../_shared';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../../../_infrastructure/dtos/DialogDataDto';
import { ClienteService } from '../../../_infrastructure/services/core/cliente/cliente.service';
import { ClienteResponse } from '../../../_infrastructure/dtos/core/cliente/ClienteResponse';
import { EstadoResponse } from '../../../_infrastructure/dtos/core/estado/EstadoResponse';
import { MunicipioResponse } from '../../../_infrastructure/dtos/core/municipio/MunicipioResponse';
import Swal from 'sweetalert2';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangeClienteDto } from '../../../_infrastructure/dtos/core/account/ChangeClienteDto';

@Component({
  selector: 'app-trocar-cliente',
  standalone: false,
  templateUrl: './trocar-cliente.component.html',
  styleUrl: './trocar-cliente.component.css'
})
export class TrocarClienteComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  clientes: ClienteResponse[] = [];
  clientesFiltrados: ClienteResponse[] = [];
  estados: EstadoResponse[] = [];
  municipios: MunicipioResponse[] = [];
  municipiosFiltrados: MunicipioResponse[] = [];
  form!: UntypedFormGroup;

  constructor(private readonly authService: AuthService,
    private readonly clienteService: ClienteService,
    private readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<TrocarClienteComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData<any>,
  ) { super(); }

  ngOnInit() {
    this.subs.sink = this.authService.currentUser.subscribe(user => {
      this.createForm();
      this.loadClientes();
      this.subscribeFormChanges();
    });
  }

  get f() {
    return this.form.controls;
  }

  private createForm() {
    this.form = this.formBuilder.group({
      estadoId: ['', Validators.required],
      municipioId: [{ value: '', disabled: true }, Validators.required],
      clienteId: [{ value: '', disabled: true }, Validators.required]
    });
  }

  private buildChangeData(): ChangeClienteDto {
    const formValue = this.form.value;

    return {
      estadoId: formValue.estadoId,
      municipioId: formValue.municipioId,
      clienteId: formValue.clienteId
    };
  }

  loadClientes() {
    Swal.showLoading();

    this.clienteService.getClienteByUsuario()
      .subscribe({
        next: (res) => {
          this.clientes = res.data;

          this.buildEstadosEMunicipios(this.clientes);
        },
        error: (error) => {
          console.error(error);
        },
        complete: () => {
          Swal.close();
        }
      });
  }

  private buildEstadosEMunicipios(clientes: ClienteResponse[]) {

    const estadoMap = new Map<string, EstadoResponse>();
    const municipioMap = new Map<string, MunicipioResponse>();

    clientes.forEach(cliente => {
      const municipio = cliente.municipio;
      const estado = municipio?.estado;

      if (estado && !estadoMap.has(estado.id)) {
        estadoMap.set(estado.id, estado);
      }

      if (municipio && !municipioMap.has(municipio.id)) {
        municipioMap.set(municipio.id, municipio);
      }
    });

    this.estados = Array.from(estadoMap.values())
      .sort((a, b) => a.nome.localeCompare(b.nome));

    this.municipios = Array.from(municipioMap.values())
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }

  getMunicipiosPorEstado(estadoId: string): MunicipioResponse[] {
    return this.municipios.filter(x => x.estado.id === estadoId);
  }

  private subscribeFormChanges() {

    // Estado → Municípios
    this.form.get('estadoId')?.valueChanges.subscribe(estadoId => {

      this.form.get('municipioId')?.reset();
      this.form.get('clienteId')?.reset();

      this.form.get('clienteId')?.disable();

      if (estadoId) {
        this.municipiosFiltrados = this.getMunicipiosPorEstado(estadoId);
        this.form.get('municipioId')?.enable();
      } else {
        this.municipiosFiltrados = [];
        this.form.get('municipioId')?.disable();
      }

      this.clientesFiltrados = [];
    });

    // Município → Clientes
    this.form.get('municipioId')?.valueChanges.subscribe(municipioId => {

      this.form.get('clienteId')?.reset();

      if (municipioId) {
        this.clientesFiltrados = this.clientes.filter(
          x => x.municipio?.id === municipioId
        );
        this.form.get('clienteId')?.enable();
      } else {
        this.clientesFiltrados = [];
        this.form.get('clienteId')?.disable();
      }
    });
  }


  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    Swal.showLoading();
    const change: ChangeClienteDto = this.buildChangeData();
    this.authService.trocarCliente(change)
      .subscribe({
        next: (result) => {
          this.dialogRef.close(result);
        },
        error: (error) => {
          console.error(error);
        },
        complete: () => {
          Swal.close();
        }
      });
  }
}
